import { render, staticRenderFns } from "./Formofpayments.vue?vue&type=template&id=0a26a301&scoped=true"
import script from "./Formofpayments.vue?vue&type=script&lang=js"
export * from "./Formofpayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26a301",
  null
  
)

export default component.exports